import React , { useState } from "react";
import PageLayout from "../../layouts/PageLayout";
import { Box, Heading, Anchor } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import PaymentModal from '../../PaymentModal';
import { createWeb3Modal, defaultConfig, useWeb3Modal, useWeb3ModalAccount, useWeb3ModalProvider, useSwitchNetwork } from '@web3modal/ethers/react';
import { Helmet } from "react-helmet-async";

export default function Workshop() {
  const { open } = useWeb3Modal();
  const { address, chainId, isConnected } = useWeb3ModalAccount();
  const { walletProvider } = useWeb3ModalProvider();
  const { switchNetwork } = useSwitchNetwork();

  const [showModal, setShowModal] = useState(false);
  const [priceModal, setPriceModal] = useState(null);
  const [downloadLinkModal, setDownloadLinkModal] = useState(null);

  const handleShow = (link, price) => {
    if(isConnected){
      setPriceModal(price);
      setDownloadLinkModal(link);
      setShowModal(true);
    }else{
      open();
    }
  }
  const handleClose = () => setShowModal(false);

    return (
        <PageLayout>
        <Helmet>
          <title>0xFactory Workshop</title>
          <meta name="description" content="Join our Blockchain Intensive Workshop for Beginners, where you will learn all the basic concepts of Blockchain and create your own project yourself during the course." />
          <meta name="keywords" content="workshop, 0xfactory, crypto workshop, blockchain workshop" />
          <meta name="author" content="0xFactory" />

          {/* Open Graph (for Facebook, LinkedIn, etc.) */}
          <meta property="og:title" content="0xFactory Workshop" />
          <meta property="og:description" content="Join our Blockchain Intensive Workshop for Beginners, where you will learn all the basic concepts of Blockchain and create your own project yourself during the course." />
          <meta property="og:image" content="https://0xfactory.com/images/blockchain2.png" />
          <meta property="og:url" content="https://0xfactory.com/workshop" />
          <meta property="og:type" content="website" />

          {/* Twitter Card (for Twitter sharing) */}
          <meta name="twitter:title" content="0xFactory Workshop" />
          <meta name="twitter:description" content="Join our Blockchain Intensive Workshop for Beginners, where you will learn all the basic concepts of Blockchain and create your own project yourself during the course." />
          <meta name="twitter:image" content="https://0xfactory.com/images/blockchain2.png" />
          <meta name="twitter:card" content="workshop" />
        </Helmet>

            <Container fluid>
                <Heading as="h2" className="mc-overview-title">Workshop</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={8} xl={8}>
                                <div>
                                  Join our Blockchain Intensive Workshop for Beginners, where you will learn all the basic concepts of Blockchain and create your own project yourself during the course.
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h1>Coming Soon</h1>
                                </div>
                                <br />
                                <div className="text-center">
                                  <h2 style={{color: 'yellow'}}>🚀 Let's build your own crypto project together!</h2>
                                </div>
                                <br/>
                                <div>
                                    <h3>Workshop Topics :</h3>
                                </div>
                                <br/>
                                <div><h3>1- Create Your Own Token.</h3></div>
                                <br />
                                <div><h3>2- Manage Your Web Hosting.</h3></div>
                                <br />
                                <div><h3>3- Create Presale Website.</h3></div>
                                <br />
                                <div><h3>4- Create Airdrop Website.</h3></div>
                                <br />
                                <div><h3>5- Create Liquidity Pool and Listing on PancakeSwap.</h3></div>
                                <br />
                                <div><h3>6- Create Swap Website For Your Token.</h3></div>
                                <br />
                                <div><h3>7- Create Stable Coin Like USDT.</h3></div>
                                <br />
                                <div><h3>8- Create Swap Website For Your Stable Coin.</h3></div>
                                <br />
                                <br />
                                <div><h3 style={{color: 'lightgreen'}}>Duration: 5 Days (2 hours daily)</h3></div>
                                <br />
                                <div><h3 style={{color: 'lightgreen'}}>Location: </h3></div>
                                <br/>
                                <div><h3 style={{color: 'lightgreen'}}>🔥 Limited to 5 students</h3></div>
                                <br />
                                <div><h3 style={{color: 'lightgreen'}}>Language: English & Arabic</h3></div>
                                <br/>
                                <h4><h3 style={{color: 'lightgreen'}}>Price : $300</h3></h4>
                                <br />
                                <div><h3 style={{color: 'yellow'}}>Trainer: Mohamed Abdel Razek (0xFactory Founder)</h3></div>
                                <br/>
                                <div className="text-center">
                                <a href="https://0xfactory.com/" target="_blank" rel="noreferrer"><h3 style={{color: 'lightblue'}}>Book Your Seat!</h3></a>
                                &nbsp;&nbsp;|&nbsp;&nbsp;
                                <a href="https://t.me/mohamedmox" target="_blank" rel="noreferrer"><h3 style={{color: 'lightblue'}}>Contact us</h3></a>
                                </div>
                                <br/>
                            </Col>
                            <Col xs={12} sm={4} xl={4}>
                                <Box>
                                    <div className="text-center">
                                        <img src="images/blockchain2.png" width={"100%"} alt="Social Image" />
                                    </div>
                                    <br/>
                                </Box>
                            </Col>
                    </Row>
                    <PaymentModal show={showModal} handleClose={handleClose} downloadLink={downloadLinkModal} price={priceModal} />
                </Container>
        </PageLayout>
    )
}
